import { render, staticRenderFns } from "./museum-of-fine-arts.vue?vue&type=template&id=d4a3d68e&scoped=true&"
import script from "./museum-of-fine-arts.vue?vue&type=script&lang=js&"
export * from "./museum-of-fine-arts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a3d68e",
  null
  
)

export default component.exports